module.exports = __webpack_public_path__ + "img/solena-flag-new.027733e6.png";